import { bp as te, bq as ne, bF as fe } from "./helpers-458d7e27.js";
import ue, { forwardRef as re, useRef as J, useEffect as H, useContext as ce } from "react";
import { T as de, I as pe, g as ge } from "./pp-react-text-input.esm-853a9847.js";
function M(i) {
  "@babel/helpers - typeof";
  return M = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
    return typeof n;
  } : function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, M(i);
}
function _(i, n) {
  if (!(i instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function Q(i, n) {
  for (var e = 0; e < n.length; e++) {
    var u = n[e];
    u.enumerable = u.enumerable || !1, u.configurable = !0, "value" in u && (u.writable = !0), Object.defineProperty(i, u.key, u);
  }
}
function y(i, n, e) {
  return n && Q(i.prototype, n), e && Q(i, e), Object.defineProperty(i, "prototype", {
    writable: !1
  }), i;
}
function ve(i, n, e) {
  return n in i ? Object.defineProperty(i, n, {
    value: e,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : i[n] = e, i;
}
function B(i, n) {
  if (typeof n != "function" && n !== null)
    throw new TypeError("Super expression must either be null or a function");
  i.prototype = Object.create(n && n.prototype, {
    constructor: {
      value: i,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(i, "prototype", {
    writable: !1
  }), n && $(i, n);
}
function p(i) {
  return p = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, p(i);
}
function $(i, n) {
  return $ = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(u, t) {
    return u.__proto__ = t, u;
  }, $(i, n);
}
function me() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function ke(i, n) {
  if (i == null)
    return {};
  var e = {}, u = Object.keys(i), t, r;
  for (r = 0; r < u.length; r++)
    t = u[r], !(n.indexOf(t) >= 0) && (e[t] = i[t]);
  return e;
}
function L(i, n) {
  if (i == null)
    return {};
  var e = ke(i, n), u, t;
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(i);
    for (t = 0; t < r.length; t++)
      u = r[t], !(n.indexOf(u) >= 0) && Object.prototype.propertyIsEnumerable.call(i, u) && (e[u] = i[u]);
  }
  return e;
}
function _e(i) {
  if (i === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return i;
}
function ye(i, n) {
  if (n && (typeof n == "object" || typeof n == "function"))
    return n;
  if (n !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _e(i);
}
function x(i) {
  var n = me();
  return function() {
    var u = p(i), t;
    if (n) {
      var r = p(this).constructor;
      t = Reflect.construct(u, arguments, r);
    } else
      t = u.apply(this, arguments);
    return ye(this, t);
  };
}
function ie(i, n) {
  for (; !Object.prototype.hasOwnProperty.call(i, n) && (i = p(i), i !== null); )
    ;
  return i;
}
function v() {
  return typeof Reflect < "u" && Reflect.get ? v = Reflect.get.bind() : v = function(n, e, u) {
    var t = ie(n, e);
    if (t) {
      var r = Object.getOwnPropertyDescriptor(t, e);
      return r.get ? r.get.call(arguments.length < 3 ? n : u) : r.value;
    }
  }, v.apply(this, arguments);
}
function I(i, n, e, u) {
  return typeof Reflect < "u" && Reflect.set ? I = Reflect.set : I = function(r, a, s, o) {
    var l = ie(r, a), h;
    if (l) {
      if (h = Object.getOwnPropertyDescriptor(l, a), h.set)
        return h.set.call(o, s), !0;
      if (!h.writable)
        return !1;
    }
    if (h = Object.getOwnPropertyDescriptor(o, a), h) {
      if (!h.writable)
        return !1;
      h.value = s, Object.defineProperty(o, a, h);
    } else
      ve(o, a, s);
    return !0;
  }, I(i, n, e, u);
}
function P(i, n, e, u, t) {
  var r = I(i, n, e, u || i);
  if (!r && t)
    throw new Error("failed to set property");
  return e;
}
function C(i, n) {
  return Ce(i) || be(i, n) || ae(i, n) || Be();
}
function Ee(i) {
  return Ae(i) || Fe(i) || ae(i) || Se();
}
function Ae(i) {
  if (Array.isArray(i))
    return z(i);
}
function Ce(i) {
  if (Array.isArray(i))
    return i;
}
function Fe(i) {
  if (typeof Symbol < "u" && i[Symbol.iterator] != null || i["@@iterator"] != null)
    return Array.from(i);
}
function be(i, n) {
  var e = i == null ? null : typeof Symbol < "u" && i[Symbol.iterator] || i["@@iterator"];
  if (e != null) {
    var u = [], t = !0, r = !1, a, s;
    try {
      for (e = e.call(i); !(t = (a = e.next()).done) && (u.push(a.value), !(n && u.length === n)); t = !0)
        ;
    } catch (o) {
      r = !0, s = o;
    } finally {
      try {
        !t && e.return != null && e.return();
      } finally {
        if (r)
          throw s;
      }
    }
    return u;
  }
}
function ae(i, n) {
  if (i) {
    if (typeof i == "string")
      return z(i, n);
    var e = Object.prototype.toString.call(i).slice(8, -1);
    if (e === "Object" && i.constructor && (e = i.constructor.name), e === "Map" || e === "Set")
      return Array.from(i);
    if (e === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e))
      return z(i, n);
  }
}
function z(i, n) {
  (n == null || n > i.length) && (n = i.length);
  for (var e = 0, u = new Array(n); e < n; e++)
    u[e] = i[e];
  return u;
}
function Se() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Be() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var k = /* @__PURE__ */ function() {
  function i(n) {
    _(this, i), Object.assign(this, {
      inserted: "",
      rawInserted: "",
      skip: !1,
      tailShift: 0
    }, n);
  }
  return y(i, [{
    key: "aggregate",
    value: function(e) {
      return this.rawInserted += e.rawInserted, this.skip = this.skip || e.skip, this.inserted += e.inserted, this.tailShift += e.tailShift, this;
    }
    /** Total offset considering all changes */
  }, {
    key: "offset",
    get: function() {
      return this.tailShift + this.inserted.length;
    }
  }]), i;
}();
function R(i) {
  return typeof i == "string" || i instanceof String;
}
var d = {
  NONE: "NONE",
  LEFT: "LEFT",
  FORCE_LEFT: "FORCE_LEFT",
  RIGHT: "RIGHT",
  FORCE_RIGHT: "FORCE_RIGHT"
};
function xe(i) {
  switch (i) {
    case d.LEFT:
      return d.FORCE_LEFT;
    case d.RIGHT:
      return d.FORCE_RIGHT;
    default:
      return i;
  }
}
function U(i) {
  return i.replace(/([.*+?^=!:${}()|[\]\/\\])/g, "\\$1");
}
function G(i) {
  return Array.isArray(i) ? i : [i, new k()];
}
function q(i, n) {
  if (n === i)
    return !0;
  var e = Array.isArray(n), u = Array.isArray(i), t;
  if (e && u) {
    if (n.length != i.length)
      return !1;
    for (t = 0; t < n.length; t++)
      if (!q(n[t], i[t]))
        return !1;
    return !0;
  }
  if (e != u)
    return !1;
  if (n && i && M(n) === "object" && M(i) === "object") {
    var r = n instanceof Date, a = i instanceof Date;
    if (r && a)
      return n.getTime() == i.getTime();
    if (r != a)
      return !1;
    var s = n instanceof RegExp, o = i instanceof RegExp;
    if (s && o)
      return n.toString() == i.toString();
    if (s != o)
      return !1;
    var l = Object.keys(n);
    for (t = 0; t < l.length; t++)
      if (!Object.prototype.hasOwnProperty.call(i, l[t]))
        return !1;
    for (t = 0; t < l.length; t++)
      if (!q(i[l[t]], n[l[t]]))
        return !1;
    return !0;
  } else if (n && i && typeof n == "function" && typeof i == "function")
    return n.toString() === i.toString();
  return !1;
}
var De = /* @__PURE__ */ function() {
  function i(n, e, u, t) {
    for (_(this, i), this.value = n, this.cursorPos = e, this.oldValue = u, this.oldSelection = t; this.value.slice(0, this.startChangePos) !== this.oldValue.slice(0, this.startChangePos); )
      --this.oldSelection.start;
  }
  return y(i, [{
    key: "startChangePos",
    get: function() {
      return Math.min(this.cursorPos, this.oldSelection.start);
    }
    /**
      Inserted symbols count
      @readonly
    */
  }, {
    key: "insertedCount",
    get: function() {
      return this.cursorPos - this.startChangePos;
    }
    /**
      Inserted symbols
      @readonly
    */
  }, {
    key: "inserted",
    get: function() {
      return this.value.substr(this.startChangePos, this.insertedCount);
    }
    /**
      Removed symbols count
      @readonly
    */
  }, {
    key: "removedCount",
    get: function() {
      return Math.max(this.oldSelection.end - this.startChangePos || // for Delete
      this.oldValue.length - this.value.length, 0);
    }
    /**
      Removed symbols
      @readonly
    */
  }, {
    key: "removed",
    get: function() {
      return this.oldValue.substr(this.startChangePos, this.removedCount);
    }
    /**
      Unchanged head symbols
      @readonly
    */
  }, {
    key: "head",
    get: function() {
      return this.value.substring(0, this.startChangePos);
    }
    /**
      Unchanged tail symbols
      @readonly
    */
  }, {
    key: "tail",
    get: function() {
      return this.value.substring(this.startChangePos + this.insertedCount);
    }
    /**
      Remove direction
      @readonly
    */
  }, {
    key: "removeDirection",
    get: function() {
      return !this.removedCount || this.insertedCount ? d.NONE : (this.oldSelection.end === this.cursorPos || this.oldSelection.start === this.cursorPos) && // if not range removed (event with backspace)
      this.oldSelection.end === this.oldSelection.start ? d.RIGHT : d.LEFT;
    }
  }]), i;
}(), F = /* @__PURE__ */ function() {
  function i() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, u = arguments.length > 2 ? arguments[2] : void 0;
    _(this, i), this.value = n, this.from = e, this.stop = u;
  }
  return y(i, [{
    key: "toString",
    value: function() {
      return this.value;
    }
  }, {
    key: "extend",
    value: function(e) {
      this.value += String(e);
    }
  }, {
    key: "appendTo",
    value: function(e) {
      return e.append(this.toString(), {
        tail: !0
      }).aggregate(e._appendPlaceholder());
    }
  }, {
    key: "state",
    get: function() {
      return {
        value: this.value,
        from: this.from,
        stop: this.stop
      };
    },
    set: function(e) {
      Object.assign(this, e);
    }
  }, {
    key: "unshift",
    value: function(e) {
      if (!this.value.length || e != null && this.from >= e)
        return "";
      var u = this.value[0];
      return this.value = this.value.slice(1), u;
    }
  }, {
    key: "shift",
    value: function() {
      if (!this.value.length)
        return "";
      var e = this.value[this.value.length - 1];
      return this.value = this.value.slice(0, -1), e;
    }
  }]), i;
}();
function g(i) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return new g.InputMask(i, n);
}
var D = /* @__PURE__ */ function() {
  function i(n) {
    _(this, i), this._value = "", this._update(Object.assign({}, i.DEFAULTS, n)), this.isInitialized = !0;
  }
  return y(i, [{
    key: "updateOptions",
    value: function(e) {
      Object.keys(e).length && this.withValueRefresh(this._update.bind(this, e));
    }
    /**
      Sets new options
      @protected
    */
  }, {
    key: "_update",
    value: function(e) {
      Object.assign(this, e);
    }
    /** Mask state */
  }, {
    key: "state",
    get: function() {
      return {
        _value: this.value
      };
    },
    set: function(e) {
      this._value = e._value;
    }
    /** Resets value */
  }, {
    key: "reset",
    value: function() {
      this._value = "";
    }
    /** */
  }, {
    key: "value",
    get: function() {
      return this._value;
    },
    set: function(e) {
      this.resolve(e);
    }
    /** Resolve new value */
  }, {
    key: "resolve",
    value: function(e) {
      return this.reset(), this.append(e, {
        input: !0
      }, ""), this.doCommit(), this.value;
    }
    /** */
  }, {
    key: "unmaskedValue",
    get: function() {
      return this.value;
    },
    set: function(e) {
      this.reset(), this.append(e, {}, ""), this.doCommit();
    }
    /** */
  }, {
    key: "typedValue",
    get: function() {
      return this.doParse(this.value);
    },
    set: function(e) {
      this.value = this.doFormat(e);
    }
    /** Value that includes raw user input */
  }, {
    key: "rawInputValue",
    get: function() {
      return this.extractInput(0, this.value.length, {
        raw: !0
      });
    },
    set: function(e) {
      this.reset(), this.append(e, {
        raw: !0
      }, ""), this.doCommit();
    }
    /** */
  }, {
    key: "isComplete",
    get: function() {
      return !0;
    }
    /** */
  }, {
    key: "isFilled",
    get: function() {
      return this.isComplete;
    }
    /** Finds nearest input position in direction */
  }, {
    key: "nearestInputPos",
    value: function(e, u) {
      return e;
    }
    /** Extracts value in range considering flags */
  }, {
    key: "extractInput",
    value: function() {
      var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
      return this.value.slice(e, u);
    }
    /** Extracts tail in range */
  }, {
    key: "extractTail",
    value: function() {
      var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
      return new F(this.extractInput(e, u), e);
    }
    /** Appends tail */
    // $FlowFixMe no ideas
  }, {
    key: "appendTail",
    value: function(e) {
      return R(e) && (e = new F(String(e))), e.appendTo(this);
    }
    /** Appends char */
  }, {
    key: "_appendCharRaw",
    value: function(e) {
      return e ? (this._value += e, new k({
        inserted: e,
        rawInserted: e
      })) : new k();
    }
    /** Appends char */
  }, {
    key: "_appendChar",
    value: function(e) {
      var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = arguments.length > 2 ? arguments[2] : void 0, r = this.state, a, s = G(this.doPrepare(e, u)), o = C(s, 2);
      if (e = o[0], a = o[1], a = a.aggregate(this._appendCharRaw(e, u)), a.inserted) {
        var l, h = this.doValidate(u) !== !1;
        if (h && t != null) {
          var f = this.state;
          this.overwrite === !0 && (l = t.state, t.unshift(this.value.length));
          var c = this.appendTail(t);
          h = c.rawInserted === t.toString(), !(h && c.inserted) && this.overwrite === "shift" && (this.state = f, l = t.state, t.shift(), c = this.appendTail(t), h = c.rawInserted === t.toString()), h && c.inserted && (this.state = f);
        }
        h || (a = new k(), this.state = r, t && l && (t.state = l));
      }
      return a;
    }
    /** Appends optional placeholder at end */
  }, {
    key: "_appendPlaceholder",
    value: function() {
      return new k();
    }
    /** Appends optional eager placeholder at end */
  }, {
    key: "_appendEager",
    value: function() {
      return new k();
    }
    /** Appends symbols considering flags */
    // $FlowFixMe no ideas
  }, {
    key: "append",
    value: function(e, u, t) {
      if (!R(e))
        throw new Error("value should be string");
      var r = new k(), a = R(t) ? new F(String(t)) : t;
      u != null && u.tail && (u._beforeTailState = this.state);
      for (var s = 0; s < e.length; ++s)
        r.aggregate(this._appendChar(e[s], u, a));
      return a != null && (r.tailShift += this.appendTail(a).tailShift), this.eager && u !== null && u !== void 0 && u.input && e && r.aggregate(this._appendEager()), r;
    }
    /** */
  }, {
    key: "remove",
    value: function() {
      var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
      return this._value = this.value.slice(0, e) + this.value.slice(u), new k();
    }
    /** Calls function and reapplies current value */
  }, {
    key: "withValueRefresh",
    value: function(e) {
      if (this._refreshing || !this.isInitialized)
        return e();
      this._refreshing = !0;
      var u = this.rawInputValue, t = this.value, r = e();
      return this.rawInputValue = u, this.value && this.value !== t && t.indexOf(this.value) === 0 && this.append(t.slice(this.value.length), {}, ""), delete this._refreshing, r;
    }
    /** */
  }, {
    key: "runIsolated",
    value: function(e) {
      if (this._isolated || !this.isInitialized)
        return e(this);
      this._isolated = !0;
      var u = this.state, t = e(this);
      return this.state = u, delete this._isolated, t;
    }
    /**
      Prepares string before mask processing
      @protected
    */
  }, {
    key: "doPrepare",
    value: function(e) {
      var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      return this.prepare ? this.prepare(e, this, u) : e;
    }
    /**
      Validates if value is acceptable
      @protected
    */
  }, {
    key: "doValidate",
    value: function(e) {
      return (!this.validate || this.validate(this.value, this, e)) && (!this.parent || this.parent.doValidate(e));
    }
    /**
      Does additional processing in the end of editing
      @protected
    */
  }, {
    key: "doCommit",
    value: function() {
      this.commit && this.commit(this.value, this);
    }
    /** */
  }, {
    key: "doFormat",
    value: function(e) {
      return this.format ? this.format(e, this) : e;
    }
    /** */
  }, {
    key: "doParse",
    value: function(e) {
      return this.parse ? this.parse(e, this) : e;
    }
    /** */
  }, {
    key: "splice",
    value: function(e, u, t, r) {
      var a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
        input: !0
      }, s = e + u, o = this.extractTail(s), l;
      this.eager && (r = xe(r), l = this.extractInput(0, s, {
        raw: !0
      }));
      var h = this.nearestInputPos(e, u > 1 && e !== 0 && !this.eager ? d.NONE : r), f = new k({
        tailShift: h - e
        // adjust tailShift if start was aligned
      }).aggregate(this.remove(h));
      if (this.eager && r !== d.NONE && l === this.rawInputValue)
        if (r === d.FORCE_LEFT)
          for (var c; l === this.rawInputValue && (c = this.value.length); )
            f.aggregate(new k({
              tailShift: -1
            })).aggregate(this.remove(c - 1));
        else
          r === d.FORCE_RIGHT && o.unshift();
      return f.aggregate(this.append(t, a, o));
    }
  }, {
    key: "maskEquals",
    value: function(e) {
      return this.mask === e;
    }
  }, {
    key: "typedValueEquals",
    value: function(e) {
      var u = this.typedValue;
      return e === u || i.EMPTY_VALUES.includes(e) && i.EMPTY_VALUES.includes(u) || this.doFormat(e) === this.doFormat(this.typedValue);
    }
  }]), i;
}();
D.DEFAULTS = {
  format: function(n) {
    return n;
  },
  parse: function(n) {
    return n;
  }
};
D.EMPTY_VALUES = [void 0, null, ""];
g.Masked = D;
function se(i) {
  if (i == null)
    throw new Error("mask property should be defined");
  return i instanceof RegExp ? g.MaskedRegExp : R(i) ? g.MaskedPattern : i instanceof Date || i === Date ? g.MaskedDate : i instanceof Number || typeof i == "number" || i === Number ? g.MaskedNumber : Array.isArray(i) || i === Array ? g.MaskedDynamic : g.Masked && i.prototype instanceof g.Masked ? i : i instanceof g.Masked ? i.constructor : i instanceof Function ? g.MaskedFunction : (console.warn("Mask not found for mask", i), g.Masked);
}
function O(i) {
  if (g.Masked && i instanceof g.Masked)
    return i;
  i = Object.assign({}, i);
  var n = i.mask;
  if (g.Masked && n instanceof g.Masked)
    return n;
  var e = se(n);
  if (!e)
    throw new Error("Masked class is not found for provided mask, appropriate module needs to be import manually before creating mask.");
  return new e(i);
}
g.createMask = O;
var Te = ["mask"], Pe = {
  0: /\d/,
  a: /[\u0041-\u005A\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/,
  // http://stackoverflow.com/a/22075070
  "*": /./
}, oe = /* @__PURE__ */ function() {
  function i(n) {
    _(this, i);
    var e = n.mask, u = L(n, Te);
    this.masked = O({
      mask: e
    }), Object.assign(this, u);
  }
  return y(i, [{
    key: "reset",
    value: function() {
      this.isFilled = !1, this.masked.reset();
    }
  }, {
    key: "remove",
    value: function() {
      var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length;
      return e === 0 && u >= 1 ? (this.isFilled = !1, this.masked.remove(e, u)) : new k();
    }
  }, {
    key: "value",
    get: function() {
      return this.masked.value || (this.isFilled && !this.isOptional ? this.placeholderChar : "");
    }
  }, {
    key: "unmaskedValue",
    get: function() {
      return this.masked.unmaskedValue;
    }
  }, {
    key: "isComplete",
    get: function() {
      return !!this.masked.value || this.isOptional;
    }
  }, {
    key: "_appendChar",
    value: function(e) {
      var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      if (this.isFilled)
        return new k();
      var t = this.masked.state, r = this.masked._appendChar(e, u);
      return r.inserted && this.doValidate(u) === !1 && (r.inserted = r.rawInserted = "", this.masked.state = t), !r.inserted && !this.isOptional && !this.lazy && !u.input && (r.inserted = this.placeholderChar), r.skip = !r.inserted && !this.isOptional, this.isFilled = !!r.inserted, r;
    }
  }, {
    key: "append",
    value: function() {
      var e;
      return (e = this.masked).append.apply(e, arguments);
    }
  }, {
    key: "_appendPlaceholder",
    value: function() {
      var e = new k();
      return this.isFilled || this.isOptional || (this.isFilled = !0, e.inserted = this.placeholderChar), e;
    }
  }, {
    key: "_appendEager",
    value: function() {
      return new k();
    }
  }, {
    key: "extractTail",
    value: function() {
      var e;
      return (e = this.masked).extractTail.apply(e, arguments);
    }
  }, {
    key: "appendTail",
    value: function() {
      var e;
      return (e = this.masked).appendTail.apply(e, arguments);
    }
  }, {
    key: "extractInput",
    value: function() {
      var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length, t = arguments.length > 2 ? arguments[2] : void 0;
      return this.masked.extractInput(e, u, t);
    }
  }, {
    key: "nearestInputPos",
    value: function(e) {
      var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : d.NONE, t = 0, r = this.value.length, a = Math.min(Math.max(e, t), r);
      switch (u) {
        case d.LEFT:
        case d.FORCE_LEFT:
          return this.isComplete ? a : t;
        case d.RIGHT:
        case d.FORCE_RIGHT:
          return this.isComplete ? a : r;
        case d.NONE:
        default:
          return a;
      }
    }
  }, {
    key: "doValidate",
    value: function() {
      var e, u;
      return (e = this.masked).doValidate.apply(e, arguments) && (!this.parent || (u = this.parent).doValidate.apply(u, arguments));
    }
  }, {
    key: "doCommit",
    value: function() {
      this.masked.doCommit();
    }
  }, {
    key: "state",
    get: function() {
      return {
        masked: this.masked.state,
        isFilled: this.isFilled
      };
    },
    set: function(e) {
      this.masked.state = e.masked, this.isFilled = e.isFilled;
    }
  }]), i;
}(), le = /* @__PURE__ */ function() {
  function i(n) {
    _(this, i), Object.assign(this, n), this._value = "", this.isFixed = !0;
  }
  return y(i, [{
    key: "value",
    get: function() {
      return this._value;
    }
  }, {
    key: "unmaskedValue",
    get: function() {
      return this.isUnmasking ? this.value : "";
    }
  }, {
    key: "reset",
    value: function() {
      this._isRawInput = !1, this._value = "";
    }
  }, {
    key: "remove",
    value: function() {
      var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this._value.length;
      return this._value = this._value.slice(0, e) + this._value.slice(u), this._value || (this._isRawInput = !1), new k();
    }
  }, {
    key: "nearestInputPos",
    value: function(e) {
      var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : d.NONE, t = 0, r = this._value.length;
      switch (u) {
        case d.LEFT:
        case d.FORCE_LEFT:
          return t;
        case d.NONE:
        case d.RIGHT:
        case d.FORCE_RIGHT:
        default:
          return r;
      }
    }
  }, {
    key: "extractInput",
    value: function() {
      var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this._value.length, t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      return t.raw && this._isRawInput && this._value.slice(e, u) || "";
    }
  }, {
    key: "isComplete",
    get: function() {
      return !0;
    }
  }, {
    key: "isFilled",
    get: function() {
      return !!this._value;
    }
  }, {
    key: "_appendChar",
    value: function(e) {
      var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = new k();
      if (this._value)
        return t;
      var r = this.char === e, a = r && (this.isUnmasking || u.input || u.raw) && (!u.raw || !this.eager) && !u.tail;
      return a && (t.rawInserted = this.char), this._value = t.inserted = this.char, this._isRawInput = a && (u.raw || u.input), t;
    }
  }, {
    key: "_appendEager",
    value: function() {
      return this._appendChar(this.char, {
        tail: !0
      });
    }
  }, {
    key: "_appendPlaceholder",
    value: function() {
      var e = new k();
      return this._value || (this._value = e.inserted = this.char), e;
    }
  }, {
    key: "extractTail",
    value: function() {
      return arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length, new F("");
    }
    // $FlowFixMe no ideas
  }, {
    key: "appendTail",
    value: function(e) {
      return R(e) && (e = new F(String(e))), e.appendTo(this);
    }
  }, {
    key: "append",
    value: function(e, u, t) {
      var r = this._appendChar(e[0], u);
      return t != null && (r.tailShift += this.appendTail(t).tailShift), r;
    }
  }, {
    key: "doCommit",
    value: function() {
    }
  }, {
    key: "state",
    get: function() {
      return {
        _value: this._value,
        _isRawInput: this._isRawInput
      };
    },
    set: function(e) {
      Object.assign(this, e);
    }
  }]), i;
}(), Re = ["chunks"], ee = /* @__PURE__ */ function() {
  function i() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    _(this, i), this.chunks = n, this.from = e;
  }
  return y(i, [{
    key: "toString",
    value: function() {
      return this.chunks.map(String).join("");
    }
    // $FlowFixMe no ideas
  }, {
    key: "extend",
    value: function(e) {
      if (String(e)) {
        R(e) && (e = new F(String(e)));
        var u = this.chunks[this.chunks.length - 1], t = u && // if stops are same or tail has no stop
        (u.stop === e.stop || e.stop == null) && // if tail chunk goes just after last chunk
        e.from === u.from + u.toString().length;
        if (e instanceof F)
          t ? u.extend(e.toString()) : this.chunks.push(e);
        else if (e instanceof i) {
          if (e.stop == null)
            for (var r; e.chunks.length && e.chunks[0].stop == null; )
              r = e.chunks.shift(), r.from += e.from, this.extend(r);
          e.toString() && (e.stop = e.blockIndex, this.chunks.push(e));
        }
      }
    }
  }, {
    key: "appendTo",
    value: function(e) {
      if (!(e instanceof g.MaskedPattern)) {
        var u = new F(this.toString());
        return u.appendTo(e);
      }
      for (var t = new k(), r = 0; r < this.chunks.length && !t.skip; ++r) {
        var a = this.chunks[r], s = e._mapPosToBlock(e.value.length), o = a.stop, l = void 0;
        if (o != null && // if block not found or stop is behind lastBlock
        (!s || s.index <= o) && ((a instanceof i || // for continuous block also check if stop is exist
        e._stops.indexOf(o) >= 0) && t.aggregate(e._appendPlaceholder(o)), l = a instanceof i && e._blocks[o]), l) {
          var h = l.appendTail(a);
          h.skip = !1, t.aggregate(h), e._value += h.inserted;
          var f = a.toString().slice(h.rawInserted.length);
          f && t.aggregate(e.append(f, {
            tail: !0
          }));
        } else
          t.aggregate(e.append(a.toString(), {
            tail: !0
          }));
      }
      return t;
    }
  }, {
    key: "state",
    get: function() {
      return {
        chunks: this.chunks.map(function(e) {
          return e.state;
        }),
        from: this.from,
        stop: this.stop,
        blockIndex: this.blockIndex
      };
    },
    set: function(e) {
      var u = e.chunks, t = L(e, Re);
      Object.assign(this, t), this.chunks = u.map(function(r) {
        var a = "chunks" in r ? new i() : new F();
        return a.state = r, a;
      });
    }
  }, {
    key: "unshift",
    value: function(e) {
      if (!this.chunks.length || e != null && this.from >= e)
        return "";
      for (var u = e != null ? e - this.from : e, t = 0; t < this.chunks.length; ) {
        var r = this.chunks[t], a = r.unshift(u);
        if (r.toString()) {
          if (!a)
            break;
          ++t;
        } else
          this.chunks.splice(t, 1);
        if (a)
          return a;
      }
      return "";
    }
  }, {
    key: "shift",
    value: function() {
      if (!this.chunks.length)
        return "";
      for (var e = this.chunks.length - 1; 0 <= e; ) {
        var u = this.chunks[e], t = u.shift();
        if (u.toString()) {
          if (!t)
            break;
          --e;
        } else
          this.chunks.splice(e, 1);
        if (t)
          return t;
      }
      return "";
    }
  }]), i;
}(), Oe = /* @__PURE__ */ function() {
  function i(n, e) {
    _(this, i), this.masked = n, this._log = [];
    var u = n._mapPosToBlock(e) || (e < 0 ? (
      // first
      {
        index: 0,
        offset: 0
      }
    ) : (
      // last
      {
        index: this.masked._blocks.length,
        offset: 0
      }
    )), t = u.offset, r = u.index;
    this.offset = t, this.index = r, this.ok = !1;
  }
  return y(i, [{
    key: "block",
    get: function() {
      return this.masked._blocks[this.index];
    }
  }, {
    key: "pos",
    get: function() {
      return this.masked._blockStartPos(this.index) + this.offset;
    }
  }, {
    key: "state",
    get: function() {
      return {
        index: this.index,
        offset: this.offset,
        ok: this.ok
      };
    },
    set: function(e) {
      Object.assign(this, e);
    }
  }, {
    key: "pushState",
    value: function() {
      this._log.push(this.state);
    }
  }, {
    key: "popState",
    value: function() {
      var e = this._log.pop();
      return this.state = e, e;
    }
  }, {
    key: "bindBlock",
    value: function() {
      this.block || (this.index < 0 && (this.index = 0, this.offset = 0), this.index >= this.masked._blocks.length && (this.index = this.masked._blocks.length - 1, this.offset = this.block.value.length));
    }
  }, {
    key: "_pushLeft",
    value: function(e) {
      for (this.pushState(), this.bindBlock(); 0 <= this.index; --this.index, this.offset = ((u = this.block) === null || u === void 0 ? void 0 : u.value.length) || 0) {
        var u;
        if (e())
          return this.ok = !0;
      }
      return this.ok = !1;
    }
  }, {
    key: "_pushRight",
    value: function(e) {
      for (this.pushState(), this.bindBlock(); this.index < this.masked._blocks.length; ++this.index, this.offset = 0)
        if (e())
          return this.ok = !0;
      return this.ok = !1;
    }
  }, {
    key: "pushLeftBeforeFilled",
    value: function() {
      var e = this;
      return this._pushLeft(function() {
        if (!(e.block.isFixed || !e.block.value) && (e.offset = e.block.nearestInputPos(e.offset, d.FORCE_LEFT), e.offset !== 0))
          return !0;
      });
    }
  }, {
    key: "pushLeftBeforeInput",
    value: function() {
      var e = this;
      return this._pushLeft(function() {
        if (!e.block.isFixed)
          return e.offset = e.block.nearestInputPos(e.offset, d.LEFT), !0;
      });
    }
  }, {
    key: "pushLeftBeforeRequired",
    value: function() {
      var e = this;
      return this._pushLeft(function() {
        if (!(e.block.isFixed || e.block.isOptional && !e.block.value))
          return e.offset = e.block.nearestInputPos(e.offset, d.LEFT), !0;
      });
    }
  }, {
    key: "pushRightBeforeFilled",
    value: function() {
      var e = this;
      return this._pushRight(function() {
        if (!(e.block.isFixed || !e.block.value) && (e.offset = e.block.nearestInputPos(e.offset, d.FORCE_RIGHT), e.offset !== e.block.value.length))
          return !0;
      });
    }
  }, {
    key: "pushRightBeforeInput",
    value: function() {
      var e = this;
      return this._pushRight(function() {
        if (!e.block.isFixed)
          return e.offset = e.block.nearestInputPos(e.offset, d.NONE), !0;
      });
    }
  }, {
    key: "pushRightBeforeRequired",
    value: function() {
      var e = this;
      return this._pushRight(function() {
        if (!(e.block.isFixed || e.block.isOptional && !e.block.value))
          return e.offset = e.block.nearestInputPos(e.offset, d.NONE), !0;
      });
    }
  }]), i;
}(), we = /* @__PURE__ */ function(i) {
  B(e, i);
  var n = x(e);
  function e() {
    return _(this, e), n.apply(this, arguments);
  }
  return y(e, [{
    key: "_update",
    value: (
      /**
        @override
        @param {Object} opts
      */
      function(t) {
        t.mask && (t.validate = function(r) {
          return r.search(t.mask) >= 0;
        }), v(p(e.prototype), "_update", this).call(this, t);
      }
    )
  }]), e;
}(D);
g.MaskedRegExp = we;
var Ie = ["_blocks"], b = /* @__PURE__ */ function(i) {
  B(e, i);
  var n = x(e);
  function e() {
    var u = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return _(this, e), u.definitions = Object.assign({}, Pe, u.definitions), n.call(this, Object.assign({}, e.DEFAULTS, u));
  }
  return y(e, [{
    key: "_update",
    value: function() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      t.definitions = Object.assign({}, this.definitions, t.definitions), v(p(e.prototype), "_update", this).call(this, t), this._rebuildMask();
    }
    /** */
  }, {
    key: "_rebuildMask",
    value: function() {
      var t = this, r = this.definitions;
      this._blocks = [], this._stops = [], this._maskedBlocks = {};
      var a = this.mask;
      if (!(!a || !r))
        for (var s = !1, o = !1, l = 0; l < a.length; ++l) {
          if (this.blocks) {
            var h = function() {
              var A = a.slice(l), S = Object.keys(t.blocks).filter(function(T) {
                return A.indexOf(T) === 0;
              });
              S.sort(function(T, j) {
                return j.length - T.length;
              });
              var E = S[0];
              if (E) {
                var w = O(Object.assign({
                  parent: t,
                  lazy: t.lazy,
                  eager: t.eager,
                  placeholderChar: t.placeholderChar,
                  overwrite: t.overwrite
                }, t.blocks[E]));
                return w && (t._blocks.push(w), t._maskedBlocks[E] || (t._maskedBlocks[E] = []), t._maskedBlocks[E].push(t._blocks.length - 1)), l += E.length - 1, "continue";
              }
            }();
            if (h === "continue")
              continue;
          }
          var f = a[l], c = f in r;
          if (f === e.STOP_CHAR) {
            this._stops.push(this._blocks.length);
            continue;
          }
          if (f === "{" || f === "}") {
            s = !s;
            continue;
          }
          if (f === "[" || f === "]") {
            o = !o;
            continue;
          }
          if (f === e.ESCAPE_CHAR) {
            if (++l, f = a[l], !f)
              break;
            c = !1;
          }
          var m = c ? new oe({
            parent: this,
            lazy: this.lazy,
            eager: this.eager,
            placeholderChar: this.placeholderChar,
            mask: r[f],
            isOptional: o
          }) : new le({
            char: f,
            eager: this.eager,
            isUnmasking: s
          });
          this._blocks.push(m);
        }
    }
    /**
      @override
    */
  }, {
    key: "state",
    get: function() {
      return Object.assign({}, v(p(e.prototype), "state", this), {
        _blocks: this._blocks.map(function(t) {
          return t.state;
        })
      });
    },
    set: function(t) {
      var r = t._blocks, a = L(t, Ie);
      this._blocks.forEach(function(s, o) {
        return s.state = r[o];
      }), P(p(e.prototype), "state", a, this, !0);
    }
    /**
      @override
    */
  }, {
    key: "reset",
    value: function() {
      v(p(e.prototype), "reset", this).call(this), this._blocks.forEach(function(t) {
        return t.reset();
      });
    }
    /**
      @override
    */
  }, {
    key: "isComplete",
    get: function() {
      return this._blocks.every(function(t) {
        return t.isComplete;
      });
    }
    /**
      @override
    */
  }, {
    key: "isFilled",
    get: function() {
      return this._blocks.every(function(t) {
        return t.isFilled;
      });
    }
  }, {
    key: "isFixed",
    get: function() {
      return this._blocks.every(function(t) {
        return t.isFixed;
      });
    }
  }, {
    key: "isOptional",
    get: function() {
      return this._blocks.every(function(t) {
        return t.isOptional;
      });
    }
    /**
      @override
    */
  }, {
    key: "doCommit",
    value: function() {
      this._blocks.forEach(function(t) {
        return t.doCommit();
      }), v(p(e.prototype), "doCommit", this).call(this);
    }
    /**
      @override
    */
  }, {
    key: "unmaskedValue",
    get: function() {
      return this._blocks.reduce(function(t, r) {
        return t += r.unmaskedValue;
      }, "");
    },
    set: function(t) {
      P(p(e.prototype), "unmaskedValue", t, this, !0);
    }
    /**
      @override
    */
  }, {
    key: "value",
    get: function() {
      return this._blocks.reduce(function(t, r) {
        return t += r.value;
      }, "");
    },
    set: function(t) {
      P(p(e.prototype), "value", t, this, !0);
    }
    /**
      @override
    */
  }, {
    key: "appendTail",
    value: function(t) {
      return v(p(e.prototype), "appendTail", this).call(this, t).aggregate(this._appendPlaceholder());
    }
    /**
      @override
    */
  }, {
    key: "_appendEager",
    value: function() {
      var t, r = new k(), a = (t = this._mapPosToBlock(this.value.length)) === null || t === void 0 ? void 0 : t.index;
      if (a == null)
        return r;
      this._blocks[a].isFilled && ++a;
      for (var s = a; s < this._blocks.length; ++s) {
        var o = this._blocks[s]._appendEager();
        if (!o.inserted)
          break;
        r.aggregate(o);
      }
      return r;
    }
    /**
      @override
    */
  }, {
    key: "_appendCharRaw",
    value: function(t) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = this._mapPosToBlock(this.value.length), s = new k();
      if (!a)
        return s;
      for (var o = a.index; ; ++o) {
        var l, h, f = this._blocks[o];
        if (!f)
          break;
        var c = f._appendChar(t, Object.assign({}, r, {
          _beforeTailState: (l = r._beforeTailState) === null || l === void 0 || (h = l._blocks) === null || h === void 0 ? void 0 : h[o]
        })), m = c.skip;
        if (s.aggregate(c), m || c.rawInserted)
          break;
      }
      return s;
    }
    /**
      @override
    */
  }, {
    key: "extractTail",
    value: function() {
      var t = this, r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length, s = new ee();
      return r === a || this._forEachBlocksInRange(r, a, function(o, l, h, f) {
        var c = o.extractTail(h, f);
        c.stop = t._findStopBefore(l), c.from = t._blockStartPos(l), c instanceof ee && (c.blockIndex = l), s.extend(c);
      }), s;
    }
    /**
      @override
    */
  }, {
    key: "extractInput",
    value: function() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length, a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      if (t === r)
        return "";
      var s = "";
      return this._forEachBlocksInRange(t, r, function(o, l, h, f) {
        s += o.extractInput(h, f, a);
      }), s;
    }
  }, {
    key: "_findStopBefore",
    value: function(t) {
      for (var r, a = 0; a < this._stops.length; ++a) {
        var s = this._stops[a];
        if (s <= t)
          r = s;
        else
          break;
      }
      return r;
    }
    /** Appends placeholder depending on laziness */
  }, {
    key: "_appendPlaceholder",
    value: function(t) {
      var r = this, a = new k();
      if (this.lazy && t == null)
        return a;
      var s = this._mapPosToBlock(this.value.length);
      if (!s)
        return a;
      var o = s.index, l = t ?? this._blocks.length;
      return this._blocks.slice(o, l).forEach(function(h) {
        if (!h.lazy || t != null) {
          var f = h._blocks != null ? [h._blocks.length] : [], c = h._appendPlaceholder.apply(h, f);
          r._value += c.inserted, a.aggregate(c);
        }
      }), a;
    }
    /** Finds block in pos */
  }, {
    key: "_mapPosToBlock",
    value: function(t) {
      for (var r = "", a = 0; a < this._blocks.length; ++a) {
        var s = this._blocks[a], o = r.length;
        if (r += s.value, t <= r.length)
          return {
            index: a,
            offset: t - o
          };
      }
    }
    /** */
  }, {
    key: "_blockStartPos",
    value: function(t) {
      return this._blocks.slice(0, t).reduce(function(r, a) {
        return r += a.value.length;
      }, 0);
    }
    /** */
  }, {
    key: "_forEachBlocksInRange",
    value: function(t) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length, a = arguments.length > 2 ? arguments[2] : void 0, s = this._mapPosToBlock(t);
      if (s) {
        var o = this._mapPosToBlock(r), l = o && s.index === o.index, h = s.offset, f = o && l ? o.offset : this._blocks[s.index].value.length;
        if (a(this._blocks[s.index], s.index, h, f), o && !l) {
          for (var c = s.index + 1; c < o.index; ++c)
            a(this._blocks[c], c, 0, this._blocks[c].value.length);
          a(this._blocks[o.index], o.index, 0, o.offset);
        }
      }
    }
    /**
      @override
    */
  }, {
    key: "remove",
    value: function() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length, a = v(p(e.prototype), "remove", this).call(this, t, r);
      return this._forEachBlocksInRange(t, r, function(s, o, l, h) {
        a.aggregate(s.remove(l, h));
      }), a;
    }
    /**
      @override
    */
  }, {
    key: "nearestInputPos",
    value: function(t) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : d.NONE;
      if (!this._blocks.length)
        return 0;
      var a = new Oe(this, t);
      if (r === d.NONE)
        return a.pushRightBeforeInput() || (a.popState(), a.pushLeftBeforeInput()) ? a.pos : this.value.length;
      if (r === d.LEFT || r === d.FORCE_LEFT) {
        if (r === d.LEFT) {
          if (a.pushRightBeforeFilled(), a.ok && a.pos === t)
            return t;
          a.popState();
        }
        if (a.pushLeftBeforeInput(), a.pushLeftBeforeRequired(), a.pushLeftBeforeFilled(), r === d.LEFT) {
          if (a.pushRightBeforeInput(), a.pushRightBeforeRequired(), a.ok && a.pos <= t || (a.popState(), a.ok && a.pos <= t))
            return a.pos;
          a.popState();
        }
        return a.ok ? a.pos : r === d.FORCE_LEFT ? 0 : (a.popState(), a.ok || (a.popState(), a.ok) ? a.pos : 0);
      }
      return r === d.RIGHT || r === d.FORCE_RIGHT ? (a.pushRightBeforeInput(), a.pushRightBeforeRequired(), a.pushRightBeforeFilled() ? a.pos : r === d.FORCE_RIGHT ? this.value.length : (a.popState(), a.ok || (a.popState(), a.ok) ? a.pos : this.nearestInputPos(t, d.LEFT))) : t;
    }
    /** Get block by name */
  }, {
    key: "maskedBlock",
    value: function(t) {
      return this.maskedBlocks(t)[0];
    }
    /** Get all blocks by name */
  }, {
    key: "maskedBlocks",
    value: function(t) {
      var r = this, a = this._maskedBlocks[t];
      return a ? a.map(function(s) {
        return r._blocks[s];
      }) : [];
    }
  }]), e;
}(D);
b.DEFAULTS = {
  lazy: !0,
  placeholderChar: "_"
};
b.STOP_CHAR = "`";
b.ESCAPE_CHAR = "\\";
b.InputDefinition = oe;
b.FixedDefinition = le;
g.MaskedPattern = b;
var V = /* @__PURE__ */ function(i) {
  B(e, i);
  var n = x(e);
  function e() {
    return _(this, e), n.apply(this, arguments);
  }
  return y(e, [{
    key: "_matchFrom",
    get: (
      /**
        Optionally sets max length of pattern.
        Used when pattern length is longer then `to` param length. Pads zeros at start in this case.
      */
      /** Min bound */
      /** Max bound */
      /** */
      function() {
        return this.maxLength - String(this.from).length;
      }
    )
    /**
      @override
    */
  }, {
    key: "_update",
    value: function(t) {
      t = Object.assign({
        to: this.to || 0,
        from: this.from || 0,
        maxLength: this.maxLength || 0
      }, t);
      var r = String(t.to).length;
      t.maxLength != null && (r = Math.max(r, t.maxLength)), t.maxLength = r;
      for (var a = String(t.from).padStart(r, "0"), s = String(t.to).padStart(r, "0"), o = 0; o < s.length && s[o] === a[o]; )
        ++o;
      t.mask = s.slice(0, o).replace(/0/g, "\\0") + "0".repeat(r - o), v(p(e.prototype), "_update", this).call(this, t);
    }
    /**
      @override
    */
  }, {
    key: "isComplete",
    get: function() {
      return v(p(e.prototype), "isComplete", this) && !!this.value;
    }
  }, {
    key: "boundaries",
    value: function(t) {
      var r = "", a = "", s = t.match(/^(\D*)(\d*)(\D*)/) || [], o = C(s, 3), l = o[1], h = o[2];
      return h && (r = "0".repeat(l.length) + h, a = "9".repeat(l.length) + h), r = r.padEnd(this.maxLength, "0"), a = a.padEnd(this.maxLength, "9"), [r, a];
    }
    // TODO str is a single char everytime
    /**
      @override
    */
  }, {
    key: "doPrepare",
    value: function(t) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a, s = G(v(p(e.prototype), "doPrepare", this).call(this, t.replace(/\D/g, ""), r)), o = C(s, 2);
      if (t = o[0], a = o[1], !this.autofix || !t)
        return t;
      var l = String(this.from).padStart(this.maxLength, "0"), h = String(this.to).padStart(this.maxLength, "0"), f = this.value + t;
      if (f.length > this.maxLength)
        return "";
      var c = this.boundaries(f), m = C(c, 2), A = m[0], S = m[1];
      return Number(S) < this.from ? l[f.length - 1] : Number(A) > this.to ? this.autofix === "pad" && f.length < this.maxLength ? ["", a.aggregate(this.append(l[f.length - 1] + t, r))] : h[f.length - 1] : t;
    }
    /**
      @override
    */
  }, {
    key: "doValidate",
    value: function() {
      var t, r = this.value, a = r.search(/[^0]/);
      if (a === -1 && r.length <= this._matchFrom)
        return !0;
      for (var s = this.boundaries(r), o = C(s, 2), l = o[0], h = o[1], f = arguments.length, c = new Array(f), m = 0; m < f; m++)
        c[m] = arguments[m];
      return this.from <= Number(h) && Number(l) <= this.to && (t = v(p(e.prototype), "doValidate", this)).call.apply(t, [this].concat(c));
    }
  }]), e;
}(b);
g.MaskedRange = V;
var Y = /* @__PURE__ */ function(i) {
  B(e, i);
  var n = x(e);
  function e(u) {
    return _(this, e), n.call(this, Object.assign({}, e.DEFAULTS, u));
  }
  return y(e, [{
    key: "_update",
    value: function(t) {
      t.mask === Date && delete t.mask, t.pattern && (t.mask = t.pattern);
      var r = t.blocks;
      t.blocks = Object.assign({}, e.GET_DEFAULT_BLOCKS()), t.min && (t.blocks.Y.from = t.min.getFullYear()), t.max && (t.blocks.Y.to = t.max.getFullYear()), t.min && t.max && t.blocks.Y.from === t.blocks.Y.to && (t.blocks.m.from = t.min.getMonth() + 1, t.blocks.m.to = t.max.getMonth() + 1, t.blocks.m.from === t.blocks.m.to && (t.blocks.d.from = t.min.getDate(), t.blocks.d.to = t.max.getDate())), Object.assign(t.blocks, this.blocks, r), Object.keys(t.blocks).forEach(function(a) {
        var s = t.blocks[a];
        !("autofix" in s) && "autofix" in t && (s.autofix = t.autofix);
      }), v(p(e.prototype), "_update", this).call(this, t);
    }
    /**
      @override
    */
  }, {
    key: "doValidate",
    value: function() {
      for (var t, r = this.date, a = arguments.length, s = new Array(a), o = 0; o < a; o++)
        s[o] = arguments[o];
      return (t = v(p(e.prototype), "doValidate", this)).call.apply(t, [this].concat(s)) && (!this.isComplete || this.isDateExist(this.value) && r != null && (this.min == null || this.min <= r) && (this.max == null || r <= this.max));
    }
    /** Checks if date is exists */
  }, {
    key: "isDateExist",
    value: function(t) {
      return this.format(this.parse(t, this), this).indexOf(t) >= 0;
    }
    /** Parsed Date */
  }, {
    key: "date",
    get: function() {
      return this.typedValue;
    },
    set: function(t) {
      this.typedValue = t;
    }
    /**
      @override
    */
  }, {
    key: "typedValue",
    get: function() {
      return this.isComplete ? v(p(e.prototype), "typedValue", this) : null;
    },
    set: function(t) {
      P(p(e.prototype), "typedValue", t, this, !0);
    }
    /**
      @override
    */
  }, {
    key: "maskEquals",
    value: function(t) {
      return t === Date || v(p(e.prototype), "maskEquals", this).call(this, t);
    }
  }]), e;
}(b);
Y.DEFAULTS = {
  pattern: "d{.}`m{.}`Y",
  format: function(n) {
    if (!n)
      return "";
    var e = String(n.getDate()).padStart(2, "0"), u = String(n.getMonth() + 1).padStart(2, "0"), t = n.getFullYear();
    return [e, u, t].join(".");
  },
  parse: function(n) {
    var e = n.split("."), u = C(e, 3), t = u[0], r = u[1], a = u[2];
    return new Date(a, r - 1, t);
  }
};
Y.GET_DEFAULT_BLOCKS = function() {
  return {
    d: {
      mask: V,
      from: 1,
      to: 31,
      maxLength: 2
    },
    m: {
      mask: V,
      from: 1,
      to: 12,
      maxLength: 2
    },
    Y: {
      mask: V,
      from: 1900,
      to: 9999
    }
  };
};
g.MaskedDate = Y;
var W = /* @__PURE__ */ function() {
  function i() {
    _(this, i);
  }
  return y(i, [{
    key: "selectionStart",
    get: (
      /** */
      /** */
      /** */
      /** Safely returns selection start */
      function() {
        var e;
        try {
          e = this._unsafeSelectionStart;
        } catch {
        }
        return e ?? this.value.length;
      }
    )
    /** Safely returns selection end */
  }, {
    key: "selectionEnd",
    get: function() {
      var e;
      try {
        e = this._unsafeSelectionEnd;
      } catch {
      }
      return e ?? this.value.length;
    }
    /** Safely sets element selection */
  }, {
    key: "select",
    value: function(e, u) {
      if (!(e == null || u == null || e === this.selectionStart && u === this.selectionEnd))
        try {
          this._unsafeSelect(e, u);
        } catch {
        }
    }
    /** Should be overriden in subclasses */
  }, {
    key: "_unsafeSelect",
    value: function(e, u) {
    }
    /** Should be overriden in subclasses */
  }, {
    key: "isActive",
    get: function() {
      return !1;
    }
    /** Should be overriden in subclasses */
  }, {
    key: "bindEvents",
    value: function(e) {
    }
    /** Should be overriden in subclasses */
  }, {
    key: "unbindEvents",
    value: function() {
    }
  }]), i;
}();
g.MaskElement = W;
var N = /* @__PURE__ */ function(i) {
  B(e, i);
  var n = x(e);
  function e(u) {
    var t;
    return _(this, e), t = n.call(this), t.input = u, t._handlers = {}, t;
  }
  return y(e, [{
    key: "rootElement",
    get: function() {
      var t, r, a;
      return (t = (r = (a = this.input).getRootNode) === null || r === void 0 ? void 0 : r.call(a)) !== null && t !== void 0 ? t : document;
    }
    /**
      Is element in focus
      @readonly
    */
  }, {
    key: "isActive",
    get: function() {
      return this.input === this.rootElement.activeElement;
    }
    /**
      Returns HTMLElement selection start
      @override
    */
  }, {
    key: "_unsafeSelectionStart",
    get: function() {
      return this.input.selectionStart;
    }
    /**
      Returns HTMLElement selection end
      @override
    */
  }, {
    key: "_unsafeSelectionEnd",
    get: function() {
      return this.input.selectionEnd;
    }
    /**
      Sets HTMLElement selection
      @override
    */
  }, {
    key: "_unsafeSelect",
    value: function(t, r) {
      this.input.setSelectionRange(t, r);
    }
    /**
      HTMLElement value
      @override
    */
  }, {
    key: "value",
    get: function() {
      return this.input.value;
    },
    set: function(t) {
      this.input.value = t;
    }
    /**
      Binds HTMLElement events to mask internal events
      @override
    */
  }, {
    key: "bindEvents",
    value: function(t) {
      var r = this;
      Object.keys(t).forEach(function(a) {
        return r._toggleEventHandler(e.EVENTS_MAP[a], t[a]);
      });
    }
    /**
      Unbinds HTMLElement events to mask internal events
      @override
    */
  }, {
    key: "unbindEvents",
    value: function() {
      var t = this;
      Object.keys(this._handlers).forEach(function(r) {
        return t._toggleEventHandler(r);
      });
    }
    /** */
  }, {
    key: "_toggleEventHandler",
    value: function(t, r) {
      this._handlers[t] && (this.input.removeEventListener(t, this._handlers[t]), delete this._handlers[t]), r && (this.input.addEventListener(t, r), this._handlers[t] = r);
    }
  }]), e;
}(W);
N.EVENTS_MAP = {
  selectionChange: "keydown",
  input: "input",
  drop: "drop",
  click: "click",
  focus: "focus",
  commit: "blur"
};
g.HTMLMaskElement = N;
var he = /* @__PURE__ */ function(i) {
  B(e, i);
  var n = x(e);
  function e() {
    return _(this, e), n.apply(this, arguments);
  }
  return y(e, [{
    key: "_unsafeSelectionStart",
    get: (
      /**
        Returns HTMLElement selection start
        @override
      */
      function() {
        var t = this.rootElement, r = t.getSelection && t.getSelection(), a = r && r.anchorOffset, s = r && r.focusOffset;
        return s == null || a == null || a < s ? a : s;
      }
    )
    /**
      Returns HTMLElement selection end
      @override
    */
  }, {
    key: "_unsafeSelectionEnd",
    get: function() {
      var t = this.rootElement, r = t.getSelection && t.getSelection(), a = r && r.anchorOffset, s = r && r.focusOffset;
      return s == null || a == null || a > s ? a : s;
    }
    /**
      Sets HTMLElement selection
      @override
    */
  }, {
    key: "_unsafeSelect",
    value: function(t, r) {
      if (this.rootElement.createRange) {
        var a = this.rootElement.createRange();
        a.setStart(this.input.firstChild || this.input, t), a.setEnd(this.input.lastChild || this.input, r);
        var s = this.rootElement, o = s.getSelection && s.getSelection();
        o && (o.removeAllRanges(), o.addRange(a));
      }
    }
    /**
      HTMLElement value
      @override
    */
  }, {
    key: "value",
    get: function() {
      return this.input.textContent;
    },
    set: function(t) {
      this.input.textContent = t;
    }
  }]), e;
}(N);
g.HTMLContenteditableMaskElement = he;
var Ve = ["mask"], Me = /* @__PURE__ */ function() {
  function i(n, e) {
    _(this, i), this.el = n instanceof W ? n : n.isContentEditable && n.tagName !== "INPUT" && n.tagName !== "TEXTAREA" ? new he(n) : new N(n), this.masked = O(e), this._listeners = {}, this._value = "", this._unmaskedValue = "", this._saveSelection = this._saveSelection.bind(this), this._onInput = this._onInput.bind(this), this._onChange = this._onChange.bind(this), this._onDrop = this._onDrop.bind(this), this._onFocus = this._onFocus.bind(this), this._onClick = this._onClick.bind(this), this.alignCursor = this.alignCursor.bind(this), this.alignCursorFriendly = this.alignCursorFriendly.bind(this), this._bindEvents(), this.updateValue(), this._onChange();
  }
  return y(i, [{
    key: "mask",
    get: function() {
      return this.masked.mask;
    },
    set: function(e) {
      if (!this.maskEquals(e)) {
        if (!(e instanceof g.Masked) && this.masked.constructor === se(e)) {
          this.masked.updateOptions({
            mask: e
          });
          return;
        }
        var u = O({
          mask: e
        });
        u.unmaskedValue = this.masked.unmaskedValue, this.masked = u;
      }
    }
    /** Raw value */
  }, {
    key: "maskEquals",
    value: function(e) {
      var u;
      return e == null || ((u = this.masked) === null || u === void 0 ? void 0 : u.maskEquals(e));
    }
  }, {
    key: "value",
    get: function() {
      return this._value;
    },
    set: function(e) {
      this.value !== e && (this.masked.value = e, this.updateControl(), this.alignCursor());
    }
    /** Unmasked value */
  }, {
    key: "unmaskedValue",
    get: function() {
      return this._unmaskedValue;
    },
    set: function(e) {
      this.unmaskedValue !== e && (this.masked.unmaskedValue = e, this.updateControl(), this.alignCursor());
    }
    /** Typed unmasked value */
  }, {
    key: "typedValue",
    get: function() {
      return this.masked.typedValue;
    },
    set: function(e) {
      this.masked.typedValueEquals(e) || (this.masked.typedValue = e, this.updateControl(), this.alignCursor());
    }
    /**
      Starts listening to element events
      @protected
    */
  }, {
    key: "_bindEvents",
    value: function() {
      this.el.bindEvents({
        selectionChange: this._saveSelection,
        input: this._onInput,
        drop: this._onDrop,
        click: this._onClick,
        focus: this._onFocus,
        commit: this._onChange
      });
    }
    /**
      Stops listening to element events
      @protected
     */
  }, {
    key: "_unbindEvents",
    value: function() {
      this.el && this.el.unbindEvents();
    }
    /**
      Fires custom event
      @protected
     */
  }, {
    key: "_fireEvent",
    value: function(e) {
      for (var u = arguments.length, t = new Array(u > 1 ? u - 1 : 0), r = 1; r < u; r++)
        t[r - 1] = arguments[r];
      var a = this._listeners[e];
      a && a.forEach(function(s) {
        return s.apply(void 0, t);
      });
    }
    /**
      Current selection start
      @readonly
    */
  }, {
    key: "selectionStart",
    get: function() {
      return this._cursorChanging ? this._changingCursorPos : this.el.selectionStart;
    }
    /** Current cursor position */
  }, {
    key: "cursorPos",
    get: function() {
      return this._cursorChanging ? this._changingCursorPos : this.el.selectionEnd;
    },
    set: function(e) {
      !this.el || !this.el.isActive || (this.el.select(e, e), this._saveSelection());
    }
    /**
      Stores current selection
      @protected
    */
  }, {
    key: "_saveSelection",
    value: function() {
      this.value !== this.el.value && console.warn("Element value was changed outside of mask. Syncronize mask using `mask.updateValue()` to work properly."), this._selection = {
        start: this.selectionStart,
        end: this.cursorPos
      };
    }
    /** Syncronizes model value from view */
  }, {
    key: "updateValue",
    value: function() {
      this.masked.value = this.el.value, this._value = this.masked.value;
    }
    /** Syncronizes view from model value, fires change events */
  }, {
    key: "updateControl",
    value: function() {
      var e = this.masked.unmaskedValue, u = this.masked.value, t = this.unmaskedValue !== e || this.value !== u;
      this._unmaskedValue = e, this._value = u, this.el.value !== u && (this.el.value = u), t && this._fireChangeEvents();
    }
    /** Updates options with deep equal check, recreates @{link Masked} model if mask type changes */
  }, {
    key: "updateOptions",
    value: function(e) {
      var u = e.mask, t = L(e, Ve), r = !this.maskEquals(u), a = !q(this.masked, t);
      r && (this.mask = u), a && this.masked.updateOptions(t), (r || a) && this.updateControl();
    }
    /** Updates cursor */
  }, {
    key: "updateCursor",
    value: function(e) {
      e != null && (this.cursorPos = e, this._delayUpdateCursor(e));
    }
    /**
      Delays cursor update to support mobile browsers
      @private
    */
  }, {
    key: "_delayUpdateCursor",
    value: function(e) {
      var u = this;
      this._abortUpdateCursor(), this._changingCursorPos = e, this._cursorChanging = setTimeout(function() {
        u.el && (u.cursorPos = u._changingCursorPos, u._abortUpdateCursor());
      }, 10);
    }
    /**
      Fires custom events
      @protected
    */
  }, {
    key: "_fireChangeEvents",
    value: function() {
      this._fireEvent("accept", this._inputEvent), this.masked.isComplete && this._fireEvent("complete", this._inputEvent);
    }
    /**
      Aborts delayed cursor update
      @private
    */
  }, {
    key: "_abortUpdateCursor",
    value: function() {
      this._cursorChanging && (clearTimeout(this._cursorChanging), delete this._cursorChanging);
    }
    /** Aligns cursor to nearest available position */
  }, {
    key: "alignCursor",
    value: function() {
      this.cursorPos = this.masked.nearestInputPos(this.masked.nearestInputPos(this.cursorPos, d.LEFT));
    }
    /** Aligns cursor only if selection is empty */
  }, {
    key: "alignCursorFriendly",
    value: function() {
      this.selectionStart === this.cursorPos && this.alignCursor();
    }
    /** Adds listener on custom event */
  }, {
    key: "on",
    value: function(e, u) {
      return this._listeners[e] || (this._listeners[e] = []), this._listeners[e].push(u), this;
    }
    /** Removes custom event listener */
  }, {
    key: "off",
    value: function(e, u) {
      if (!this._listeners[e])
        return this;
      if (!u)
        return delete this._listeners[e], this;
      var t = this._listeners[e].indexOf(u);
      return t >= 0 && this._listeners[e].splice(t, 1), this;
    }
    /** Handles view input event */
  }, {
    key: "_onInput",
    value: function(e) {
      if (this._inputEvent = e, this._abortUpdateCursor(), !this._selection)
        return this.updateValue();
      var u = new De(
        // new state
        this.el.value,
        this.cursorPos,
        // old state
        this.value,
        this._selection
      ), t = this.masked.rawInputValue, r = this.masked.splice(u.startChangePos, u.removed.length, u.inserted, u.removeDirection, {
        input: !0,
        raw: !0
      }).offset, a = t === this.masked.rawInputValue ? u.removeDirection : d.NONE, s = this.masked.nearestInputPos(u.startChangePos + r, a);
      a !== d.NONE && (s = this.masked.nearestInputPos(s, d.NONE)), this.updateControl(), this.updateCursor(s), delete this._inputEvent;
    }
    /** Handles view change event and commits model value */
  }, {
    key: "_onChange",
    value: function() {
      this.value !== this.el.value && this.updateValue(), this.masked.doCommit(), this.updateControl(), this._saveSelection();
    }
    /** Handles view drop event, prevents by default */
  }, {
    key: "_onDrop",
    value: function(e) {
      e.preventDefault(), e.stopPropagation();
    }
    /** Restore last selection on focus */
  }, {
    key: "_onFocus",
    value: function(e) {
      this.alignCursorFriendly();
    }
    /** Restore last selection on focus */
  }, {
    key: "_onClick",
    value: function(e) {
      this.alignCursorFriendly();
    }
    /** Unbind view events and removes element reference */
  }, {
    key: "destroy",
    value: function() {
      this._unbindEvents(), this._listeners.length = 0, delete this.el;
    }
  }]), i;
}();
g.InputMask = Me;
var Z = /* @__PURE__ */ function(i) {
  B(e, i);
  var n = x(e);
  function e(u) {
    return _(this, e), n.call(this, Object.assign({}, e.DEFAULTS, u));
  }
  return y(e, [{
    key: "_update",
    value: function(t) {
      v(p(e.prototype), "_update", this).call(this, t), this._updateRegExps();
    }
    /** */
  }, {
    key: "_updateRegExps",
    value: function() {
      var t = "^" + (this.allowNegative ? "[+|\\-]?" : ""), r = "(0|([1-9]+\\d*))?", a = "\\d*", s = (this.scale ? "(" + U(this.radix) + "\\d{0," + this.scale + "})?" : "") + "$";
      this._numberRegExpInput = new RegExp(t + r + s), this._numberRegExp = new RegExp(t + a + s), this._mapToRadixRegExp = new RegExp("[" + this.mapToRadix.map(U).join("") + "]", "g"), this._thousandsSeparatorRegExp = new RegExp(U(this.thousandsSeparator), "g");
    }
    /** */
  }, {
    key: "_removeThousandsSeparators",
    value: function(t) {
      return t.replace(this._thousandsSeparatorRegExp, "");
    }
    /** */
  }, {
    key: "_insertThousandsSeparators",
    value: function(t) {
      var r = t.split(this.radix);
      return r[0] = r[0].replace(/\B(?=(\d{3})+(?!\d))/g, this.thousandsSeparator), r.join(this.radix);
    }
    /**
      @override
    */
  }, {
    key: "doPrepare",
    value: function(t) {
      var r;
      t = t.replace(this._mapToRadixRegExp, this.radix);
      for (var a = this._removeThousandsSeparators(t), s = arguments.length, o = new Array(s > 1 ? s - 1 : 0), l = 1; l < s; l++)
        o[l - 1] = arguments[l];
      var h = G((r = v(p(e.prototype), "doPrepare", this)).call.apply(r, [this, a].concat(o))), f = C(h, 2), c = f[0], m = f[1];
      return t && !a && (m.skip = !0), [c, m];
    }
    /** */
  }, {
    key: "_separatorsCount",
    value: function(t) {
      for (var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, a = 0, s = 0; s < t; ++s)
        this._value.indexOf(this.thousandsSeparator, s) === s && (++a, r && (t += this.thousandsSeparator.length));
      return a;
    }
    /** */
  }, {
    key: "_separatorsCountFromSlice",
    value: function() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._value;
      return this._separatorsCount(this._removeThousandsSeparators(t).length, !0);
    }
    /**
      @override
    */
  }, {
    key: "extractInput",
    value: function() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length, a = arguments.length > 2 ? arguments[2] : void 0, s = this._adjustRangeWithSeparators(t, r), o = C(s, 2);
      return t = o[0], r = o[1], this._removeThousandsSeparators(v(p(e.prototype), "extractInput", this).call(this, t, r, a));
    }
    /**
      @override
    */
  }, {
    key: "_appendCharRaw",
    value: function(t) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      if (!this.thousandsSeparator)
        return v(p(e.prototype), "_appendCharRaw", this).call(this, t, r);
      var a = r.tail && r._beforeTailState ? r._beforeTailState._value : this._value, s = this._separatorsCountFromSlice(a);
      this._value = this._removeThousandsSeparators(this.value);
      var o = v(p(e.prototype), "_appendCharRaw", this).call(this, t, r);
      this._value = this._insertThousandsSeparators(this._value);
      var l = r.tail && r._beforeTailState ? r._beforeTailState._value : this._value, h = this._separatorsCountFromSlice(l);
      return o.tailShift += (h - s) * this.thousandsSeparator.length, o.skip = !o.rawInserted && t === this.thousandsSeparator, o;
    }
    /** */
  }, {
    key: "_findSeparatorAround",
    value: function(t) {
      if (this.thousandsSeparator) {
        var r = t - this.thousandsSeparator.length + 1, a = this.value.indexOf(this.thousandsSeparator, r);
        if (a <= t)
          return a;
      }
      return -1;
    }
  }, {
    key: "_adjustRangeWithSeparators",
    value: function(t, r) {
      var a = this._findSeparatorAround(t);
      a >= 0 && (t = a);
      var s = this._findSeparatorAround(r);
      return s >= 0 && (r = s + this.thousandsSeparator.length), [t, r];
    }
    /**
      @override
    */
  }, {
    key: "remove",
    value: function() {
      var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.value.length, a = this._adjustRangeWithSeparators(t, r), s = C(a, 2);
      t = s[0], r = s[1];
      var o = this.value.slice(0, t), l = this.value.slice(r), h = this._separatorsCount(o.length);
      this._value = this._insertThousandsSeparators(this._removeThousandsSeparators(o + l));
      var f = this._separatorsCountFromSlice(o);
      return new k({
        tailShift: (f - h) * this.thousandsSeparator.length
      });
    }
    /**
      @override
    */
  }, {
    key: "nearestInputPos",
    value: function(t, r) {
      if (!this.thousandsSeparator)
        return t;
      switch (r) {
        case d.NONE:
        case d.LEFT:
        case d.FORCE_LEFT: {
          var a = this._findSeparatorAround(t - 1);
          if (a >= 0) {
            var s = a + this.thousandsSeparator.length;
            if (t < s || this.value.length <= s || r === d.FORCE_LEFT)
              return a;
          }
          break;
        }
        case d.RIGHT:
        case d.FORCE_RIGHT: {
          var o = this._findSeparatorAround(t);
          if (o >= 0)
            return o + this.thousandsSeparator.length;
        }
      }
      return t;
    }
    /**
      @override
    */
  }, {
    key: "doValidate",
    value: function(t) {
      var r = t.input ? this._numberRegExpInput : this._numberRegExp, a = r.test(this._removeThousandsSeparators(this.value));
      if (a) {
        var s = this.number;
        a = a && !isNaN(s) && // check min bound for negative values
        (this.min == null || this.min >= 0 || this.min <= this.number) && // check max bound for positive values
        (this.max == null || this.max <= 0 || this.number <= this.max);
      }
      return a && v(p(e.prototype), "doValidate", this).call(this, t);
    }
    /**
      @override
    */
  }, {
    key: "doCommit",
    value: function() {
      if (this.value) {
        var t = this.number, r = t;
        this.min != null && (r = Math.max(r, this.min)), this.max != null && (r = Math.min(r, this.max)), r !== t && (this.unmaskedValue = String(r));
        var a = this.value;
        this.normalizeZeros && (a = this._normalizeZeros(a)), this.padFractionalZeros && this.scale > 0 && (a = this._padFractionalZeros(a)), this._value = a;
      }
      v(p(e.prototype), "doCommit", this).call(this);
    }
    /** */
  }, {
    key: "_normalizeZeros",
    value: function(t) {
      var r = this._removeThousandsSeparators(t).split(this.radix);
      return r[0] = r[0].replace(/^(\D*)(0*)(\d*)/, function(a, s, o, l) {
        return s + l;
      }), t.length && !/\d$/.test(r[0]) && (r[0] = r[0] + "0"), r.length > 1 && (r[1] = r[1].replace(/0*$/, ""), r[1].length || (r.length = 1)), this._insertThousandsSeparators(r.join(this.radix));
    }
    /** */
  }, {
    key: "_padFractionalZeros",
    value: function(t) {
      if (!t)
        return t;
      var r = t.split(this.radix);
      return r.length < 2 && r.push(""), r[1] = r[1].padEnd(this.scale, "0"), r.join(this.radix);
    }
    /**
      @override
    */
  }, {
    key: "unmaskedValue",
    get: function() {
      return this._removeThousandsSeparators(this._normalizeZeros(this.value)).replace(this.radix, ".");
    },
    set: function(t) {
      P(p(e.prototype), "unmaskedValue", t.replace(".", this.radix), this, !0);
    }
    /**
      @override
    */
  }, {
    key: "typedValue",
    get: function() {
      return Number(this.unmaskedValue);
    },
    set: function(t) {
      P(p(e.prototype), "unmaskedValue", String(t), this, !0);
    }
    /** Parsed Number */
  }, {
    key: "number",
    get: function() {
      return this.typedValue;
    },
    set: function(t) {
      this.typedValue = t;
    }
    /**
      Is negative allowed
      @readonly
    */
  }, {
    key: "allowNegative",
    get: function() {
      return this.signed || this.min != null && this.min < 0 || this.max != null && this.max < 0;
    }
    /**
      @override
    */
  }, {
    key: "typedValueEquals",
    value: function(t) {
      return (v(p(e.prototype), "typedValueEquals", this).call(this, t) || e.EMPTY_VALUES.includes(t) && e.EMPTY_VALUES.includes(this.typedValue)) && !(t === 0 && this.value === "");
    }
  }]), e;
}(D);
Z.DEFAULTS = {
  radix: ",",
  thousandsSeparator: "",
  mapToRadix: ["."],
  scale: 2,
  signed: !1,
  normalizeZeros: !0,
  padFractionalZeros: !1
};
Z.EMPTY_VALUES = [].concat(Ee(D.EMPTY_VALUES), [0]);
g.MaskedNumber = Z;
var Le = ["name", "maskOptions", "onAccept", "onComplete", "value"], ze = {
  Range: g.MaskedRange
}, Ne = re(function(i, n) {
  var e = i.name, u = i.maskOptions, t = u === void 0 ? {
    mask: Number
  } : u, r = i.onAccept, a = i.onComplete, s = i.value, o = te(i, Le), l = J(), h = n || l, f = J(null);
  return H(function() {
    var c = f.current;
    c && c.updateOptions(t);
  }, [t]), H(function() {
    var c = f.current;
    c && (c.unmaskedValue = s);
  }, [s]), H(function() {
    var c = h.current;
    if (c && !f.current) {
      f.current = g(c, t);
      var m = f.current;
      m.on("accept", function() {
        r && r(m.value, m.unmaskedValue, m.typedValue);
      }), m.on("complete", function() {
        a && a(m.value, m.unmaskedValue, m.typedValue);
      });
    }
    return function() {
      if (f.current) {
        var A = f.current;
        A.off("accept"), A.off("complete"), A.destroy(), f.current = null;
      }
    };
  }, []), /* @__PURE__ */ ue.createElement(de, ne({
    name: e,
    value: s,
    ref: h,
    "data-ppui-info": "masked-text-input_2.0.19"
  }, o));
}), je = ["name", "maskOptions", "prefix", "suffix", "currencyType", "value"], qe = re(function(i, n) {
  var e = i.name, u = i.maskOptions, t = i.prefix, r = i.suffix, a = i.currencyType, s = a === void 0 ? "USD" : a, o = i.value, l = te(i, je), h = ce(pe), f = ge(h, u, s), c = f.currencyMaskOptions, m = f.intlCurrencyPrefix, A = f.intlCurrencySuffix, S = "decimal", E = o;
  if (c && (c.scale === 0 && (S = "numeric"), E)) {
    var w = E.split("."), T = fe(w, 2), j = T[0], K = T[1];
    if (K) {
      var X = K.substring(0, c.scale);
      E = j + (X ? "." + X : "");
    }
  }
  return /* @__PURE__ */ ue.createElement(Ne, ne({
    name: e,
    value: E,
    maskOptions: c,
    prefix: t || m,
    suffix: r || A,
    inputMode: S,
    ref: n,
    "data-ppui-info": "currency-input_2.0.19"
  }, l));
});
export {
  qe as C,
  Ne as M,
  ze as a
};
//# sourceMappingURL=PpReactCurrencyInput-cfa9b61d.js.map
